import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { selectUser } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import CommonHeadingNBtns from "../../components/common-components/CommonHeadingNBtns";
import { fetchWebsiteTabPrefenceData } from "../../redux/plans-reducers/plansSlice";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";
import { add_website_tab_preference } from "../../data/ApiEndpoints";
import "../../styles/plans/tab-preference.css";

const WebsiteTabPreference = () => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);

  const { postPutLoading } = useSelector((state) => state.common);
  const {
    websiteTabPrefenceLoading,
    websiteTabPrefenceError,
    websiteTabPrefence,
  } = useSelector((state) => state.plans);

  const [peferencedTabs, setPreferencedTabs] = useState("");
  const forminitials = {
    isRecurring: peferencedTabs.includes("recurring"),
    isODM: peferencedTabs.includes("one_time_membership"),
    isDisableRecurring: peferencedTabs.includes("none"),
  };
  const [formValues, setFormValues] = useState(forminitials);

  function getWebsiteTabPrefenceData(filters = {}) {
    dispatch(
      fetchWebsiteTabPrefenceData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const onChangeInput = (e) => {
    const { name, checked } = e.target;

    if (checked) {
      setFormValues({
        isRecurring: name === "isRecurring",
        isODM: name === "isODM",
        isDisableRecurring: name === "isDisableRecurring",
      });
    } else {
      setFormValues({
        isRecurring: false,
        isODM: false,
        isDisableRecurring: false,
      });
    }
  };

  const handleAdd = async (payload) => {
    const method = "POST";
    const endpoint = add_website_tab_preference;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        getWebsiteTabPrefenceData();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const onSubmit = () => {
    if (
      !formValues.isRecurring &&
      !formValues.isODM &&
      !formValues.isDisableRecurring
    ) {
      toast.error("Please select at least one option");
      return;
    } else {
      const userData = {
        tab_name: formValues.isRecurring
          ? "recurring"
          : formValues.isODM
          ? "one_time_membership"
          : "none",
      };

      handleAdd(userData);
    }
  };

  useEffect(() => {
    getWebsiteTabPrefenceData();
  }, []);

  useEffect(() => {
    if (
      !websiteTabPrefenceLoading &&
      !websiteTabPrefenceError &&
      websiteTabPrefence?.status &&
      websiteTabPrefence?.data
    ) {
      const tab =
        websiteTabPrefence.data?.tab_name &&
        websiteTabPrefence.data?.status === "active"
          ? websiteTabPrefence.data?.tab_name
          : null;

      setPreferencedTabs(tab);
    } else {
      setPreferencedTabs("");
    }
  }, [websiteTabPrefenceLoading, websiteTabPrefenceError, websiteTabPrefence]);

  useEffect(() => {
    if (peferencedTabs) {
      setFormValues((prev) => ({
        ...prev,
        isRecurring: peferencedTabs.includes("recurring"),
        isODM: peferencedTabs.includes("one_time_membership"),
        isDisableRecurring: peferencedTabs.includes("none"),
      }));
    }
  }, [peferencedTabs]);

  return (
    <HelmetWrapper title="WTF: Website Tab Preference">
      <Container className="bg-cloud-k px-50px website-tab-preference" fluid>
        <Row>
          <Col>
            <CommonHeadingNBtns
              title={`Manage Website Tab Preference`}
              btnTxt="Update Website Tab Preference"
              onClick={onSubmit}
              isLoading={postPutLoading}
            />

            {/* Info Tag Start */}
            <div className="info-tag">
              {/* <span className="info-icon">ℹ️</span> */}
              <span>
                The Tab Preference feature will allow you to set which tab
                should be displayed first on the gym details page.
                <br />
                For example, if the Recurring tab is selected, then on the gym
                details page of the website, the Recurring tab will be displayed
                first by default.
                <br />
                Additionally, if Disable Recurring from Website is checked, the
                Recurring tab will be hidden from the website.
              </span>
            </div>
            {/* Info Tag End */}

            <form className="formContainer">
              <div className="formInputsGrid">
                <div className="formInputBox checkbox-wrapper span2">
                  <div className={`flex-box`}>
                    <label className="checkboxLabel">
                      <input
                        type="checkbox"
                        name="isRecurring"
                        checked={formValues.isRecurring}
                        onChange={onChangeInput}
                      />
                      Recurring
                    </label>
                    <label className="checkboxLabel">
                      <input
                        type="checkbox"
                        name="isODM"
                        checked={formValues.isODM}
                        onChange={onChangeInput}
                      />
                      One Time Payment
                    </label>
                    <label className="checkboxLabel">
                      <input
                        type="checkbox"
                        name="isDisableRecurring"
                        checked={formValues.isDisableRecurring}
                        onChange={onChangeInput}
                      />
                      Disable Recurring From Website
                    </label>
                  </div>
                </div>
              </div>
            </form>
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default WebsiteTabPreference;
